/** Limites de traitement local : bornent la mémoire, le calcul et le DOM. */
export const DATASET_LIMITS = { bytes: 2 * 1024 * 1024, rows: 5000, columns: 128 } as const;
